import { useState } from 'react';
import { Card, FilterChip, Badge, Button, Modal, Input, Select } from '@getpay93/ui';
import type { InvoiceStatus } from '@getpay93/api';
import { useInvoices, useRegisterPayment, useSendReminder } from '../../data/hooks';
import { money, shortDate } from '../../lib/format';

const FILTERS: { value?: InvoiceStatus; label: string }[] = [
  { value: undefined, label: 'Todas' },
  { value: 'pending', label: 'Pendientes' },
  { value: 'overdue', label: 'Vencidas' },
  { value: 'paid', label: 'Pagadas' },
];

export function Cobros() {
  const [status, setStatus] = useState<InvoiceStatus | undefined>('pending');
  const invoices = useInvoices({ status });
  const pay = useRegisterPayment();
  const reminder = useSendReminder();
  const [payFor, setPayFor] = useState<string>('');
  const [amount, setAmount] = useState('');
  const [method, setMethod] = useState('efectivo');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={{ display: 'flex', gap: 8 }}>
        {FILTERS.map((f) => <FilterChip key={f.label} value={f.label} active={f.value === status} onClick={() => setStatus(f.value)} />)}
      </div>
      <Card padding={0}>
        {invoices.isLoading ? <p style={{ padding: 16, color: 'var(--text-hint)' }}>Cargando…</p> : null}
        {invoices.data && invoices.data.length === 0 ? <p style={{ padding: 16, color: 'var(--text-hint)' }}>Sin facturas.</p> : null}
        {(invoices.data ?? []).map((i) => (
          <div key={i.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 16px', borderBottom: '1px solid var(--border)' }}>
            <div>
              <div style={{ fontWeight: 700, color: 'var(--text-strong)' }}>{i.clientName}</div>
              <div style={{ fontSize: 13, color: 'var(--text-hint)' }}>{money(i.amount)} · vence {shortDate(i.dueDate)}</div>
            </div>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <Badge tone={i.status === 'paid' ? 'paid' : i.status === 'overdue' ? 'overdue' : 'pending'}>{i.status}</Badge>
              {i.status !== 'paid' ? (
                <>
                  <Button size="sm" variant="ghost" iconLeft="bell" onClick={() => reminder.mutate({ invoiceId: i.id })}>Recordatorio</Button>
                  <Button size="sm" onClick={() => { setPayFor(i.id); setAmount(String(i.amount)); }}>Registrar pago</Button>
                </>
              ) : null}
            </div>
          </div>
        ))}
      </Card>

      {payFor ? (
        <Modal open onClose={() => setPayFor('')} title="Registrar pago" footer={<><Button variant="ghost" onClick={() => setPayFor('')}>Cancelar</Button><Button disabled={!amount} onClick={() => pay.mutate({ invoiceId: payFor, amount: Number(amount), method }, { onSuccess: () => setPayFor('') })}>Registrar</Button></>}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <Input label="Monto" type="number" value={amount} onChange={(e) => setAmount(e.currentTarget.value)} />
            <Select label="Método" options={['efectivo', 'transferencia', 'deuna', 'otro']} value={method} onChange={(e) => setMethod(e.currentTarget.value)} />
          </div>
        </Modal>
      ) : null}
    </div>
  );
}
